// extracted by mini-css-extract-plugin
module.exports = {"container":"CompanyTitle_container__3piqc","left":"CompanyTitle_left__3G1WP","right":"CompanyTitle_right__yaqC8"};